import Tickets from './tickets';

export default Tickets;